import { gql } from '@apollo/client';

export const CREATE_TWEET_DRAFT_AD_STATUS = gql`
  mutation CreateTweetDraftAdStatus($request: TweetAdStatusRequest!) {
    CreateTweetDraftAdStatus(request: $request) {
      data
    }
  }
`;

export const UPDATE_TWEET_DRAFT_AD_STATUS = gql`
  mutation UpdateTweetDraftAdStatus($request: TweetAdStatusRequest!) {
    UpdateTweetDraftAdStatus(request: $request) {
      data
    }
  }
`;

export const CREATE_TWEET_AD_STATUS = gql`
  mutation CreateTweetAdStatus($request: TweetAdStatusRequest!) {
    CreateTweetAdStatus(request: $request) {
      data
    }
  }
`;

export const CREATE_TWEET_SCHEDULE_AD_STATUS = gql`
  mutation CreateTweetScheduledAdStatus($request: TweetAdStatusRequest!) {
    CreateTweetScheduledAdStatus(request: $request) {
      data
    }
  }
`;
